<fgb-page-header [pageTitle]="'games.page.polls.title'" [showBalance]="true" [backButtonLink]="'/games'">
  <ng-template>
    <div class="mb-3">
      <img class="w-100" [src]="'images/polls-banner.png' | contentAssetImage" />
    </div>
  </ng-template>
</fgb-page-header>
<div class="container">
  <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
    <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
    </fgbcl-game-polls-question-list>
  </ng-container>

  <!-- Shimmer Effect -->
  <ng-template #shimmerEffect>
    <div class="card bg-black" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
      <h6 class="card-title placeholder-glow text-center">
        <span class="question-shimmer-effect placeholder col-6"></span>
      </h6>
      <div class="answer-shimmer-effect-section">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
      </div>
      <div class="answer-shimmer-effect-section mt-3">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <p class="card-text placeholder-glow w-40 text-center">
          <span class="presentby-shimmer-effect placeholder col-7"></span>
        </p>
      </div>
    </div>
  </ng-template>
</div>
